import React, {Component} from 'react';
import {Route} from 'react-router-dom';
import history from './history';
import { ConnectedRouter } from 'react-router-redux';
import Loadable from 'react-loadable'
import CircularProgress from 'material-ui/CircularProgress';

const MyLoadingComponent = ({isLoading, error}) => {
    // Handle the loading state
    if (isLoading) {
        return <div><CircularProgress className="loading" size={60} thickness={6}/></div>;
    }
    // Handle the error state
    else if (error) {
        return <div>Sorry, there was a problem loading the page.</div>;
    }
    else {
        return null;
    }
};

const AsyncRegister = Loadable({
    loader: () => import("../pages/register/registerPage"),
    loading: MyLoadingComponent
});
const AsyncLogin = Loadable({
    loader: () => import("../pages/login/loginPage"),
    loading: MyLoadingComponent
});
const AsyncEvents = Loadable({
    loader: () => import("../pages/myEvents/myEventsPage"),
    loading: MyLoadingComponent
});
const AsyncAddEvent = Loadable({
    loader: () => import("../pages/addEvent"),
    loading: MyLoadingComponent
});
const AsyncCurrentEvent = Loadable({
    loader: () => import("../pages/eventDetails/eventDetailsPage.container"),
    loading: MyLoadingComponent
});
const AsyncTemplates = Loadable({
    loader: () => import("../pages/myTemplates/templatesPage"),
    loading: MyLoadingComponent
});
const AsyncPlaylist = Loadable({
    loader: () => import("../pages/recommendations/recommendationsPage"),
    loading: MyLoadingComponent
});
const AsyncUserInfo = Loadable({
    loader: () => import("../pages/userInfo/userInfoPage"),
    loading: MyLoadingComponent
});
const AsyncScanner = Loadable({
    loader: () => import("../pages/scanner/scannerPage"),
    loading: MyLoadingComponent
});
const AsyncPlanningForm = Loadable({
    loader: () => import("../pages/planningForm/planningFormPage"),
    loading: MyLoadingComponent
});
const AsyncWelcome = Loadable({
    loader: () => import("../pages/welcome/welcomePage"),
    loading: MyLoadingComponent
});
const AsyncAccount = Loadable({
    loader: () => import("../pages/account/accountPage"),
    loading: MyLoadingComponent
});
const AsyncSpotifyAuthCallback = Loadable({
    loader: () => import("../pages/eventDetails/musicList/spotifyPopupWindowPage"),
    loading: MyLoadingComponent
});

class RoutesComponent extends Component {
    render() {
        return (
            <ConnectedRouter history={history}>
                <div>
                    <Route exact path="/events/add" component={AsyncAddEvent}/>
                    <Route exact path="/" component={AsyncEvents}/>
                    {/*<Route path="/events/past" component={Buttons} />*/}
                    <Route path="/playlist" component={AsyncPlaylist} />
                    <Route path="/login" component={AsyncLogin} />
                    <Route path="/events/currentEventDetails" component={AsyncCurrentEvent} />
                    <Route path="/templates" component={AsyncTemplates} />
                    <Route path="/userInfo" component={AsyncUserInfo} />
                    <Route path="/scanner" component={AsyncScanner} />
                    <Route path="/register" component={AsyncRegister} />
                    <Route path="/welcome" component={AsyncWelcome} />
                    <Route path="/planningForm/:eventId" component={AsyncPlanningForm} />
                    <Route path="/account" component={AsyncAccount} />
                    <Route path="/auth/spotify/callback" component={AsyncSpotifyAuthCallback} />
                </div>
            </ConnectedRouter>
        );
    }
}

export default RoutesComponent;


// WEBPACK FOOTER //
// ./src/routers/routesComponent.js